"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnableCurrenciesList = exports.applyAvailableCurrencies = exports.INITIAL_CURRENCY_CODE = exports.FALLBACK_CURRENCY_CODE = void 0;
var _ramda = require("ramda");
var _static = require("@otpusk/json-api/dist/static");
var FALLBACK_CURRENCY_CODE = exports.FALLBACK_CURRENCY_CODE = _static.CURRENCIES_MAP.eur.code;
var INITIAL_CURRENCY_CODE = exports.INITIAL_CURRENCY_CODE = _static.CURRENCIES_MAP.uah.code;
var ENABLE_CURRENCIES_LIST = [_static.CURRENCIES_MAP.usd, _static.CURRENCIES_MAP.eur, _static.CURRENCIES_MAP.uah, _static.CURRENCIES_MAP.uzs, _static.CURRENCIES_MAP.mdl, _static.CURRENCIES_MAP.pln, _static.CURRENCIES_MAP.czk, _static.CURRENCIES_MAP.kzt, _static.CURRENCIES_MAP.huf];
var getEnableCurrenciesList = exports.getEnableCurrenciesList = function getEnableCurrenciesList() {
  return ENABLE_CURRENCIES_LIST;
};
var applyAvailableCurrencies = exports.applyAvailableCurrencies = function applyAvailableCurrencies(availableCurrencies) {
  if (!(0, _ramda.isEmpty)(availableCurrencies)) {
    ENABLE_CURRENCIES_LIST = (0, _ramda.filter)(function (_ref) {
      var code = _ref.code;
      return (0, _ramda.includes)(code, availableCurrencies);
    }, ENABLE_CURRENCIES_LIST);
  }
};